import pricingv4 from "../pricingv4";
import LocalStorage from 'Core/commons/LocalStorage';
import { debounce } from "lodash";
import { computeCart } from 'api/sellsyaccountmanager';
import PlansData from 'Config/authenticated/PlansData';

export default {
    namespaced: true,
    state() {
        return {
            ...pricingv4.state(),
            localStorage: new LocalStorage('cart', 'client.save'),
        }
    },
    getters: {
        ...pricingv4.getters,

        /*
         * Get the prices of licenses and return an array of them with their code name (for Cart)
         */
        getPricesPlans: (state, getters)=>{
            let prices = [];
            let licensesProducts = getters.availablesProducts.find(product =>(
                    product.code === 'pack_prospecting_sale'))?.plans || [];

            if (licensesProducts.length > 0){

                // Put enterprise plans prices as brut values.
                let enterprise =  [
                    {'code' : 'ENTERPRISE_MONTHLY', 'amountInCents' : 12000},
                    {'code' : 'ENTERPRISE_YEARLY', 'amountInCents' : 120000}
                ];
                enterprise.forEach(plan => {
                    licensesProducts.push(plan);
                })

                // Sort only code and prices in array
                for(let i = 0; i <  licensesProducts.length; i++){
                    prices[i] = { code : licensesProducts[i].code ,  price : licensesProducts[i].amountInCents};
                }
                return prices;
            }
            return [];

        },
        plansData: ()=>{
            return Object.keys(PlansData).map(i => PlansData[i]);
        },

        getLocalStorage: state => {
            return state.localStorage.get();
        },
        canGoToPayment: (state, getters) => {
            return getters.quantityPaidLicences >= 2;
        },
        /**
         * Get Bonus Pack availables for Client Cart: classics packs licenced, grouped packs licenced or selfservice enabled
         * @param {*} state 
         * @param {*} getters 
         * @returns 
         */
        bonusPacksClient: (state, getters) => {
            return [...getters.availablesPacks, ...getters.currentGroupedPacks].filter(pack => {
                return getters.packsWithLicences.find(packLicenced => packLicenced.id === pack.id)
                    || getters.groupedPacksWithLicences.find(packLicenced => packLicenced.id === pack.id)
                    || pack.subscribableByCustomer
            });
        }
    },
    mutations: {
        ...pricingv4.mutations,
        setLocalStorage(state, payload) {
            state.localStorage.set(payload)
        }
    },
    actions: {
        ...pricingv4.actions,
        computeCart: debounce(({ state, getters, commit }) => {
            commit('setComputeLoading', true);
            const payload = computeCart(state);
            return new Promise((resolve, reject) => {
                SipClient.post(`/customers/${getters.customerId}/compute-cart`, {}, 
                    {
                        ...payload,
                        country: _.isNil(payload.country) ? 'FR' : payload.country,
                    })
                    .then(res => {
                        let products = getters.products;
                        _.each(getters.products, (product, productId) => {
                            if (!res.data.products[productId]) return;

                            products[productId] = {
                                ...products[productId],
                                total: {
                                    monthly: res.data.products[productId].monthly,
                                    yearly: res.data.products[productId].yearly,
                                }
                            };
                        });
                        commit('setTaxRate', res.data.tax_rate);
                        commit('setProducts', products);
                        commit('setCartTotal', { monthly: res.data.monthly, yearly: res.data.yearly });
                        commit('setLocalStorage', {
                            customerId: getters.customerId,
                            plan: getters.currentPlan,
                            recurrency: getters.recurrency,
                            products: getters.products
                        });
                        resolve();
                    }).catch(err => {
                        reject(err);
                    }).finally(() => {
                        commit('setComputeLoading', false);
                    });
            });
        }),
        getActiveCreditCard({}, corporation) {
            return new Promise((resolve, reject) => {
                window.SellsyJS.WebServiceCaller.get(`/rest/sellsy-account-manager/corporation/` + corporation + `/creditcard`, {}, (response) => {
                    resolve(response)
                }, (error) => reject(error.response.data.error));
            });
        },
        recordStripeToken({ commit }, { corporation, token}) {
            return new Promise((resolve, reject) => {
                window.SellsyJS.WebServiceCaller.put('/rest/sellsy-account-manager/corporation/' + corporation + '/stripe-token', {}, { stripeToken: token }, (response) => {
                    if (response.error) {
                        reject(response);
                    }
                    commit('setComputeLoading', false);
                    resolve(response);
                });
            });
        },
    },
}